import { render, staticRenderFns } from "./chart-editor.vue?vue&type=template&id=332bea6c"
import script from "./chart-editor.vue?vue&type=script&lang=js"
export * from "./chart-editor.vue?vue&type=script&lang=js"
import style0 from "./chart-editor.vue?vue&type=style&index=0&id=332bea6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports